import cn from 'classnames';
import { useContext } from 'react';
import { PlayerContext } from './player';
import { ROOM } from '@consts/blackjack';
import { TMaxPlayers, TRoomSlug } from '@api/types/blackjack';
import { ReactComponent as UserIcon } from '@assets/svg/user.svg';
import Avatar from '@components/avatar';
import styles from './player.module.scss';

const MAX_PLAYERS = 5;

const EmptySeat = (): JSX.Element => {
  const roomColor: TRoomSlug = ROOM.COLORS[MAX_PLAYERS as TMaxPlayers];

  /* ClassNames */

  const figureClasses: string = cn(styles.emptySeat__pic, {
    [styles[`emptySeat__pic-color-${roomColor}`]]: roomColor,
  });

  return (
    <section className={styles.emptySeat}>
      <figure className={figureClasses}>
        <UserIcon />
      </figure>
      <p className={styles.emptySeat__name}>Empty seat</p>
    </section>
  );
};

const PlayerUser = (): JSX.Element => {
  const { player } = useContext(PlayerContext);

  if (!player) return <EmptySeat />;

  const { ready_to_play, user } = player;

  /* ClassNames */

  const userClasses: string = cn(styles.user, {
    [styles.gameStarted]: true,
    [styles.isReady]: ready_to_play,
    [styles.hit]: false,
    [styles.stand]: false,
  });

  /* Components */

  const Status: JSX.Element = <span className={styles.user__status} />;

  return (
    <section className={userClasses}>
      <div className={styles.user__wrapper}>
        <Avatar
          className={styles.user__avatar}
          src={user.avatar_url}
          alt={user.username}
        />
      </div>
      <p className={styles.user__name}>
        {true && Status}
        {user.username}
      </p>
    </section>
  );
};

export default PlayerUser;
